export default __webpack_public_path__ + "70de53f876331aa27949155e234fc2ac.mp4";